<template>
<div v-if="props.cell.type == 'splitter'" :class="{ 'render-cell-splitter' : true, 'splitter-horizontal': props.cell.direction == 'horizontal' }" :style="cellStyles">
	<page-render-cell v-for="subCell in props.cell.items" :key="subCell.id" :cell="subCell" :page="props.page" :container-size="splitterSizeTotal" :container-direction="props.cell.direction" />
</div>
<div v-else class="dx-card render-cell-container" :style="cellStyles">
	<ux-list v-if="props.cell.type == 'list'" :settings="cellSettings" :context="props.page" />
	<ux-datagrid v-else-if="props.cell.type == 'datagrid'" :settings="cellSettings" :context="props.page" />
	<ux-itemview v-else-if="props.cell.type == 'itemview'" :settings="cellSettings" :context="props.page" />
	<ux-chart v-else-if="props.cell.type == 'chart'" :settings="cellSettings" :context="props.page" />
	<ux-drive v-else-if="props.cell.type == 'drive'" :settings="cellSettings" :context="props.page" />
	<ux-calendar v-else-if="props.cell.type == 'calendar'" :settings="cellSettings" :context="props.page" />
	<ux-imageview v-else-if="props.cell.type == 'imageview'" :settings="cellSettings" :context="props.page" />
	<ux-html v-else-if="props.cell.type == 'html'" :settings="cellSettings" :context="props.page" />
</div>
</template>

<style lang="scss">
.render-cell-splitter {
	display: flex;
	flex-direction: column;
	
	&.splitter-horizontal {
		flex-direction: row;
	}
}
.render-cell-container {
	margin: 10px;
	padding: 10px;
}
</style>

<script setup>
import { defineProps, computed } from 'vue';

import UxList from '../components/ux/ux-list';
import UxDatagrid from '../components/ux/ux-datagrid';
import UxItemview from '../components/ux/ux-itemview';
import UxChart from '../components/ux/ux-chart';
import UxDrive from '../components/ux/ux-drive';
import UxCalendar from '../components/ux/ux-calendar';
import UxImageview from '../components/ux/ux-imageview';
import UxHtml from '../components/ux/ux-html';

const props = defineProps([
	'cell',					// Cell we are rendering - individual object of the layout tree from our page-view component.
	'page',					// The page object containing the cell, from the server. Full page object, with optional context object.
	'containerSize',		// The size in pixels of the container the cell is in, or undefined. This is used to calculate the percentage size of our cell for relative sizing
	'containerDirection',	// The direction of the container the cell is in, or undefined. This is used to determine if we use width/height for sizing.
]);

const splitterSizeTotal = computed(() => {
	if (!props.cell || props.cell.type != 'splitter')
		return 0;
	if (!props.cell.items || !Array.isArray(props.cell.items))
		return 0;
	// TODO: What do we do if the size isn't set?
	return props.cell.items.reduce((total, cell) => total + (cell.size || 0), 0);
});

const cellSettings = computed(() => {
	if (!props.cell || !props.page || !props.page.components)
		return {};
	return (props.cell.id in props.page.components) ? props.page.components[props.cell.id] : {};
})
const cellRelativeSize = computed(() => {
	if (!props.containerSize)
		return 0;
	return props.cell.size / props.containerSize * 100;
});

const cellStyles = computed(() => {
	if (!props.containerDirection)
		return {};
	let effectiveSize = props.containerSize ? cellRelativeSize.value : 100;
	if (props.containerDirection == 'horizontal')
		return { width: effectiveSize ? `${effectiveSize}%` : 'auto' };
	if (props.containerDirection == 'vertical')
		return { height: effectiveSize ? `${effectiveSize}%` : 'auto' };
	return {};
});

console.log(`Rendering cell ${props.cell.id} (${props.cell.type}) of size ${props.cell.size} in a container of size ${props.containerSize}`, cellStyles.value);

</script>
